import { ValidatorFn, Validators } from '@angular/forms';

export const regEx =
    '^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$';

export const emailValidator: ValidatorFn = Validators.pattern(regEx);
